import { render, staticRenderFns } from "./entityTypeTree.vue?vue&type=template&id=2f6f42f2&scoped=true&"
import script from "./entityTypeTree.vue?vue&type=script&lang=js&"
export * from "./entityTypeTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f42f2",
  null
  
)

export default component.exports